import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showHideDoneItems: {
		id: 'issue-table-hide-done-items',
		defaultMessage: 'Hide done work items',
		description:
			'Text shown in the label for toggle to enable/disable the hide done work items view',
	},
	showHideDoneItemsOldTerminology: {
		id: 'issue-table-hide-done-items.old-terminology',
		defaultMessage: 'Hide done',
		description: 'Text shown in the label for toggle to enable/disable the hide done items view',
	},
});
